import styled from 'styled-components';

export interface ISvg {
  width?: number;
  height?: number;
}

export const Svg = styled.svg<ISvg>`
  width: ${(props: ISvg) => (props.width ? `${props.width}px` : '24px')};
  height: ${(props: ISvg) => (props.height ? `${props.height}px` : '24px')};
`;
